module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAM1BMVEUAAABCicFCicFCicFCicFCicFCicFCicFCicFCicFCicFCicFCicFCicFCicFCicFCicGkTtJjAAAAEHRSTlMAj9+AEDDP70BQn78gr3Bgep25UQAAAPJJREFUeF7tlsEOwiAQRCkg0FYr//+1xsQ4VcISdppolHf08JKZddqan2Yw21whTl2eLNBjspIodoiyyMEiPtp6VNmJPD+OxuCenkB5EoKdGI9HUGcYphFsBBvBRrDWYcBFHSy/oQxWitQXW149C3UxvCmipy82ow5qY+d492wIViFuRibsb5+ywNZeg/UP0ar7PkJB1GcNCroaWhTwD2qLbKOg4Pc/CCS5oHgywNdNNlW2joKAcqIrCqJErhitauulWrl1ToStl3NwxNYJsHUKbJ0DBXFg6xzYOgm2zoCtf0tB2DqJsHX2MfJxUbn1v2FwA+ZcQulWO5CTAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f4a4.png
// module id = 987
// module chunks = 0